import { string, object } from 'yup';
var validationSchema = object().shape({
  title: string().required('Required'),
  firstname: string().required('First name is required'),
  lastname: string().required('Last name is required'),
  country: string().required('Country is required'),
  address_line1: string().min(5, 'Address should be at least 5 characters').required('Address is required'),
  city: string().required('City is required'),
  postalcode: string().required('Postal code is required'),
  state: string().required('State is required')
});
export default validationSchema;